var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfileActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 7",
    clipPath: "url(#clip0_1404_14638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4001 4.42773C10.092 4.42773 8.21411 6.30548 8.21411 8.61371C8.21411 10.9218 10.092 12.7995 12.4001 12.7995C14.7081 12.7995 16.5861 10.9218 16.5861 8.61371C16.5861 6.30548 14.7081 4.42773 12.4001 4.42773Z",
    fill: "url(#paint0_linear_1404_14638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4001 0C5.78326 0 0.400146 5.38312 0.400146 12C0.400146 15.0615 1.55316 17.8583 3.44684 19.9807C3.85242 18.1998 4.78314 16.5749 6.14215 15.3091C7.09595 14.4207 8.21198 13.7558 9.41827 13.3423C7.85089 12.3505 6.80792 10.6016 6.80792 8.61365C6.80792 5.52997 9.31665 3.02142 12.4001 3.02142C15.4836 3.02142 17.9922 5.52997 17.9922 8.61365C17.9922 10.6007 16.9501 12.349 15.3839 13.3411C16.6905 13.7886 17.8882 14.5316 18.8936 15.537C20.1221 16.7655 20.9702 18.3096 21.3525 19.9814C23.2469 17.859 24.4001 15.0619 24.4001 12C24.4001 5.38312 19.017 0 12.4001 0Z",
    fill: "url(#paint1_linear_1404_14638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.67041 21.1718C6.76001 22.9359 9.4577 24.0008 12.4 24.0008C15.3423 24.0008 18.04 22.9357 20.1296 21.1718C19.9372 19.4235 19.1515 17.7845 17.8992 16.5323C16.43 15.063 14.477 14.2539 12.4 14.2539C8.44421 14.2539 5.09979 17.2717 4.67041 21.1718Z",
    fill: "url(#paint2_linear_1404_14638)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_14638",
    x1: 12.4001,
    y1: 4.42773,
    x2: 12.4001,
    y2: 12.7995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1404_14638",
    x1: 12.4001,
    y1: -5.95492e-7,
    x2: 12.4001,
    y2: 19.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1404_14638",
    x1: 12.4,
    y1: 14.2539,
    x2: 12.4,
    y2: 24.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1404_14638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.400146)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileActive);
export default __webpack_public_path__ + "static/media/icon_profile_active.ade5dd4edf6c88b63bf1b5fb49e2d034.svg";
export { ForwardRef as ReactComponent };